/* eslint-disble */
import { dateVerify } from '../constant/formRegular.js'
import { MessageBox } from 'element-ui'
import { isNil } from 'lodash'

// 判断返回的日期是否为 YYYY-MM-DD 格式， 否则设置为空
export const verifyDate = date => {
    return dateVerify.test(date) ? date : ''
}

// 字符串 去前后空格 且 转大写
export const trimAndUpper = str => {
    return !str ? '' : str.trim().toUpperCase()
}
export const confirmBox = (msg, tip = '提示', type = 'warning') => {
    return new Promise((resolve, reject) => {
        MessageBox.confirm(msg, tip, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type,
        })
            .then(() => {
                resolve()
            })
            .catch(err => {
                reject(err)
            })
    })
}

// 获取浏览器缓存的数据字典值
export const getSessionStorageDict = (ctx, dictArray, isFormatKeyValue = false) => {
    const {
        lang: { locale },
        currentTenant: { tenantCode },
    } = ctx.$store.state
    const dict = {}
    for (let i = 0; i < dictArray.length; i++) {
        const target = sessionStorage.getItem(locale + '#' + tenantCode + '#' + dictArray[i])
        if (target) {
            dict[dictArray[i]] = JSON.parse(target)
        }
    }
    if (isFormatKeyValue) {
        Object.values(Object.values(dict)).map((v, i) => {
            dict[Object.keys(dict)[i]] = Object.entries(v).map(vv => ({ label: vv[1], value: vv[0] }))
        })
    }
    return dict
}

export function numToStr(data) {
    return [null, undefined].includes(data) ? '' : String(data)
}
// 校验小数点后两位 允许输入负数
export const validatetwo = value => {
    let validResult
    const reg = /^([\+ \-]?(([1-9]\d*)|(0)))([.]\d{0,2})?$/
    if (reg.test(value)) {
        validResult = false
    } else {
        validResult = true
    }
    return validResult
}
/*  验证数据是否被改动
    参数：object1: 标准数据     object2: 待验证数据
    返回结果：Boolean   true已改 false未改
*/
export const validationDataChange = (object1 = {}, object2 = {}) => {
    let isChange = false
    const obj1 = JSON.parse(JSON.stringify(object1))
    const obj2 = JSON.parse(JSON.stringify(object2))
    function recursive(obj1, obj2) {
        for (const key in obj1) {
            if (obj1.hasOwnProperty(key)) {
                const item1 = obj1[key]
                const item2 = obj2[key]
                if (item1 instanceof Array && item2 instanceof Array && item1.length !== item2.length) {
                    isChange = true
                    recursive(item1, item2)
                } else if (typeof item1 !== 'object' && item2 === undefined) {
                    isChange = true
                } else if (typeof item1 === 'object' && item2 === undefined) {
                    isChange = true
                } else if (typeof item1 === 'object' && typeof item2 === 'object') {
                    recursive(item1, item2)
                } else if (item1 === undefined && item2) {
                    isChange = true
                } else if (item1 !== item2) {
                    isChange = true
                }
            }
        }
    }
    recursive(obj1, obj2)
    return isChange
}

// 公共方法部分
// 校验输入正负数， 保留2位小数 传来的需要是string类型
export function plusOrMinus(values) {
    let newValue
    if (!/[^0-9.-]/g.test(values)) {
        newValue = values
            .replace(/[^\-\d.]/g, '')
            .replace(/\b(0+){2,}/g, '0')
            .replace(/\-{2,}/g, '-')
            .replace(/^\./g, '')
            .replace(/\.{2,}/g, '.')
            .replace('.', '$#$')
            .replace(/\./g, '')
            .replace('$#$', '.')
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[1].length) > 2) {
            newValue = parseInt(parseFloat(newValue) * 100) / 100
        }
        if (newValue.toString().split('-').length - 1 > 1) {
            newValue = parseFloat(newValue) || ''
        }
        if (newValue.toString().split('-').length > 1 && newValue.toString().split('-')[0].length > 0) {
            newValue = parseFloat(newValue) || ''
        }
        if (
            newValue.toString().length > 1 &&
            (newValue.toString().charAt(0) === '0'
                || (newValue.toString().length > 2
                    && newValue.toString().charAt(0) === '-'
                    && newValue.toString().charAt(1) === '0'
                    && newValue.toString().charAt(2) !== '.'))
            && newValue.toString().indexOf('.') < 1
        ) {
            newValue = parseFloat(newValue) || ''
        }
        // 判断整数位最多为9位
        if (newValue.toString().indexOf('.') > 0 && Number(newValue.toString().split('.')[0].length) > 9) {
            newValue = newValue.toString().substring(0, 9) + '.' + newValue.toString().split('.')[1]
        } else if (newValue.toString().indexOf('.') < 0 && Number(newValue.toString().split('.')[0].length) > 9) {
            newValue = newValue.toString().substring(0, 9)
        }
    } else {
        newValue = values.replace(/[^0-9.-]/g, '')
    }
    return newValue
}

// 脱敏转化函数
export function getSensitiveVal(val, type) {
    if (type === 'phone') {
        return val.substring(0, 4) + '*****' + val.substring(val.length - 2, val.length)
    } else if (type === 'idCard') {
        return val.substring(0, 11) + '*****' + val.substring(val.length - 2, val.length)
    } else if (type === 'bank') {
        return val.substring(0, 12) + '*****' + val.substring(val.length - 2, val.length)
    } else if (type === 'address') {
        return val.substring(0, 2) + '************'
    } else if (type === 'cname') {
        return val.substring(0, 1) + '**'
    } else {
        return val
    }
}

//校验非undefine/null/''
export function  isNone(value) {
    return !isNil(value) && value!=='';
}

// 脱敏转化函数
export function getSensitiveVal2(val, type) {
    // 如果原本就有脱敏了 直接返回数据
    if (val && val.indexOf('*****') !== -1) {
        return val
    }
    return getSensitiveVal(val, type)
}

// 对列表数据进行脱敏/不脱敏
export const handleTableDataSensitive = (_t, sensitiveKey = 'isSensitive', tableDataKey = '', keyList = [], setFlag = false, rowKey = null) => {
    try {
        if (setFlag) {
            _t[sensitiveKey] = !_t[sensitiveKey]
        }
        if (tableDataKey && keyList && keyList.length) {
            _t[tableDataKey].forEach((item) => {
                if(!rowKey || isNone(item[rowKey])) {
                    keyList.map((k) => {
                        _t.$set(item, k.showKey, _t[sensitiveKey] && item[k.dataKey] ? getSensitiveVal2(item[k.dataKey], k.type) : item[k.dataKey])
                    })
                }
            });
        }
        // console.log('handleTableDataSensitive', _t[sensitiveKey], _t[tableDataKey])
    } catch (error) {
        console.error('handleTableDataSensitive', error)
    }
}